import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  assetPanelAccordion: {
    background: 'none',
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    },
    marginLeft: '-1rem!important',
    marginRight: '-1rem!important'
  },
  assetPanelAccordionSummary: {
    backgroundColor: theme.vars.palette.background.elevation2,
    boxShadow: 'none',
    minHeight: '3rem', // fixed height
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    borderTop: `1px solid ${theme.vars.palette.divider}`,
    marginTop: '-1px',
    '&.Mui-expanded': {
      minHeight: '3rem' // stop growing when expanded
    },
    '& .MuiAccordionSummary-content': {
      margin: 0 // reset margin
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0 // stop shifting
    }
  },
  assetPanelChips: {
    marginBottom: '.5rem',
    marginRight: '.5rem'
  },
  assetPanelContent: {
    padding: '1rem'
  },
  assetPanelContentSection: {
    margin: '1rem 0 0 0'
  },
  assetPanelContentTitle: {
    fontWeight: 600
  },
  assetPanelName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
    paddingRight: '0.5rem'
  },
  assetPanelNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexDirection: 'row'
  },
  assetPanelProviderTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    width: '100%'
  }
}));

export default useStyles;
